import * as Highcharts from "highcharts";

export const chartData = {
  chart: { type: "line" },
  title: {
    text: ""
  },
  tooltip: {
    borderColor: "transparent",
    borderRadius: "3",
    formatter: function() {
      if(this.point.high){
        if(this.point.index===0){
          return this.x + ": " + Number(this.point.high).toFixed(2) + " %";
        }
        return this.x + ": " + Number(this.point.high - this.point.low).toFixed(2) + "%";

      }
      return this.x + ": " + Number(this.point.y).toFixed(2) + " %";      
    }
  },
  xAxis: {
    labels: { style: { fontSize: "12px", color: "#626262" } },
    categories: [],
  },
  yAxis: 
    {
      title: { text: "Percentage" },
      min: 10,
      max: 120,
      labels: {
        format: "{value}%"
      }
    }
  ,
  plotOptions: {
    line: {
      lineWidth: 2,
      dataLabels: {
        enabled: true,
        formatter: function() {
          if (this.point.x == this.series.data.length - 1) {
            return `Target (${this.y}%)`;
          }
        },
        style: {
          color: "#626262",
          fontSize: "12px",
          fontWeight: "bold",
          textOutline:'1px',
          }
      },
      enableMouseTracking: true
    },
    columnrange: {
      colorByPoint: true,
      colors: [
        "#007fd8",
        "#c6cdd4",
        "#d13e3b",
        "#d13e3b",
        "#d13e3b",
        "#d13e3b",
        "#d13e3b",
        "#d13e3b"
      ],
      dataLabels: { enabled: false, valueSuffix: "%" }
    }
  },
  legend: { enabled: false },
  series: [
  
    {
      showInLegend: false,
      type: "columnrange",
      name: "Overall SLA",
      data: [
        [71.15, 81.15],
        [81.15, 83.88],
        [83.88, 86.09],
        
      ]
    }, {
      type: "line",
      name: "Target",
      showInLegend: false,
      data: [90, 90, 90],
      dashStyle: "ShortDash",
      color: "#979797",
      marker: {
        enabled: false
      },
      tooltip:{
        enabled:false
      }
    }
  ]
};
